import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/UI/errors/ErrorFallBack";
import Header from "./components/main/Header";
import Footer from "./components/main/Footer";
import RouteList from "./components/home/RouteList";
import PricePage from "./components/prices/PricePage";
import Printing from "./components/printout/Printing";
import ListDoc from "./components/printout/ListDoc";
import BlankSheet from "./components/printout/BlankSheet";
import EditDoc from "./components/edit_doc/EditDoc";
import PaymentPage from "./components/payment/PaymentPage";
import VerifyUser from "./components/printout/VerifyUser";
import AdvertisementPage from "./components/adversting/AdvertisementPage";
import TopUsersPage from "./components/top_users/TopUsersPage";
import NetworkStatus from "./components/UI/elements/NetworkStatus";
import InactivityModal from "./components/UI/elements/InactivityModal";
import ApparatNotWork from "./components/UI/alerts/ApparatNotWork";
import PrinterErrorBanner from "./components/UI/alerts/PrinterErrorBanner";
import EditManyDocs from "./components/edit_doc/EditManyDocs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const isNetworkCheckNeeded = !isHomePage;
    const [isLocked, setIsLocked] = useState(false);
    const [lockMessage, setLockMessage] = useState("");
    const [lang, setLang] = useState("ru");

    // Загрузка состояния из LocalStorage
    useEffect(() => {
        const storedState = localStorage.getItem("lockState");
        if (storedState) {
            const parsedState = JSON.parse(storedState);
            setIsLocked(parsedState.isLocked);
            setLockMessage(parsedState.lockMessage || "");
            setLang(parsedState.lang || "ru");
        }
    }, []);

    // Сохранение состояния
    useEffect(() => {
        const stateToSave = { isLocked, lockMessage, lang };
        localStorage.setItem("lockState", JSON.stringify(stateToSave));
    }, [isLocked, lockMessage, lang]);

    // Слушаем lock-screen от Electron.
    // onLockScreen сам возвращает функцию отписки (в preload.js нет отдельного
    // offLockScreen) — раньше это значение отбрасывалось и подписка никогда не снималась.
    useEffect(() => {
        if (!window.electronAPI) return;
        const handler = (event, data) => {
            setIsLocked(data.status === "locked");
            setLockMessage(data.message || "");
            if (data.lang) setLang(data.lang);
        };
        const unsubscribe = window.electronAPI.onLockScreen(handler);
        return () => unsubscribe?.();
    }, []);

    // Слушаем refresh-page
    useEffect(() => {
        if (!window.electronAPI) return;
        const handler = () => {
            console.log("Получен сигнал refreshed - перезагружаем страницу");
            window.location.reload();
        };
        window.electronAPI.onRefreshPage(handler);
        return () => {
            if (window.electronAPI.offRefreshPage) {
                window.electronAPI.offRefreshPage(handler);
            }
        };
    }, []);

    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={(error, info) => {
                console.error("Глобальная ошибка:", error, info);
            }}
            onReset={() => {
                localStorage.setItem("reloadCount", "0");
            }}
        >
            <div className="min-h-screen overflow-hidden">
                <Header />
                <main>
                    <ToastContainer position="top-right" autoClose={3000} />
                    {isNetworkCheckNeeded && <NetworkStatus />}
                    <Routes>
                        <Route path="/" element={<RouteList />} />
                        <Route path="/prices" element={<PricePage />} />
                        <Route path="/printing" element={<Printing />} />
                        <Route path="/printing/verify" element={<VerifyUser />} />
                        <Route path="/printing/show_list/user" element={<ListDoc />} />
                        <Route path="/printing/blank_sheet" element={<BlankSheet />} />
                        <Route path="/printing/edit_many_docs" element={<EditManyDocs />} />
                        <Route path="/printing/show_list/:id" element={<EditDoc />} />
                        <Route path="/payments" element={<PaymentPage />} />
                        <Route path="/advertisement" element={<AdvertisementPage />} />
                        <Route path="/top_users" element={<TopUsersPage />} />
                        <Route
                            path="*"
                            element={
                                <div className="flex justify-center items-center h-screen text-2xl">
                                    Страница не найдена
                                </div>
                            }
                        />
                    </Routes>
                </main>
                <Footer />
                {!isHomePage && <InactivityModal />}
                <ApparatNotWork
                    isOpen={isLocked}
                    lang={lang}
                    message={lockMessage}
                    autoSwitchLang={true}
                />
                <PrinterErrorBanner />
            </div>
        </ErrorBoundary>
    );
}

export default App;